import React from "react";
import * as fu from "./_utils";
import * as utils from "common/utils";
import { farmYear } from "common/domain";
import ActionLink from "components/ActionLink";

const ApplicationMonth = ({ label, month, checked, name, application, onChange, reportingYear }) => (
    <label className="Checkbox" htmlFor={`${application.id}_${month}_${reportingYear}`}>
        <input className="Checkbox-input" type="checkbox" checked={checked} id={`${application.id}_${month}_${reportingYear}`} name={`${application.id}_${month}_${reportingYear}`} onChange={(e) => onChange({ type: "application", key: "appplication-month", applicationId: application.id, month: month, reportingYear: reportingYear, value: month, id: `${application.id}_${month}_${reportingYear}` }, e)} />
        <span className="Checkbox-label">{label}</span>
    </label>
);

const ActivitySummary = ({ blocks, fertiliser, onChange, deleteApplication, validation = {}, editApplication, refData }) => {
    let nutrientsOnApplication = fu.nutrientsOnApplication(fertiliser);
    let rowIndex = 0;
    const otherBlockIds = blocks.filter((b) => !["FodderCrop", "ProductiveCrop"].includes(b.type) && b.isProductive).map((c) => c.id);

    const otherBlockApplications = fertiliser.applications
        .filter((a) => a.blockIds.some((i) => otherBlockIds.includes(i)))
        .reduce((a, b) => {
            const blockApps = a.find((x) => x.blockIds.every((i) => b.blockIds.includes(i)) && b.blockIds.every((i) => x.blockIds.includes(i)));
            if (blockApps) {
                blockApps.applications.push(b);
            } else {
                a.push({
                    blockIds: b.blockIds,
                    applications: [b],
                });
            }
            return a;
        }, []);

    return otherBlockApplications.map((otherApplication, index) => {
        const _blockIcon = utils.getBlockIcon(otherApplication.type);
        const selectedBlocks = otherApplication.blockIds.map((id) => {
            return blocks.find((b) => b.id === id);
        });
        const { fertiliserUnits = [] } = refData;
        const unit = utils.valueToText(fertiliserUnits, otherApplication.applications[0].unit);

        return (
            <div key={index + 1}>
                <ul className="DataWidthTable FarmTable">
                    <li className="FarmTable-title">
                        <div className="FarmTitle">
                            <img className="FarmTitle-icon" src={_blockIcon} alt="Block Type" />
                            <div className="FarmTitle-heading">
                                <span className="FarmTitle-name">
                                    {selectedBlocks.map((block, i) => (
                                        <span key={block.id}>
                                            {i > 0 ? "| " : ""} {block.name}{" "}
                                        </span>
                                    ))}
                                </span>
                                <div className="FarmTitle-sub"></div>
                            </div>
                        </div>
                    </li>
                    {fertiliser.isLastPreviousLime && (
                        <li data-width="md-10 xl-10">
                            <div className="FarmTable-keyValuePair">
                                <div className="FarmTable-keyValue">
                                    <span className="FarmTable-key">Amount</span>
                                    <span className="FarmTable-value">{`${otherApplication.applications[0].amount} ${unit}`}</span>
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
                <div className="FarmTable-supplementary">
                    <div className="Table">
                        <table className="Calendar u-tbl-fix u-tbl-lg">
                            {!fertiliser.isLastPreviousLime && (
                                <thead>
                                    <tr className="Calendar-months">
                                        <th colSpan={3}></th>
                                        {farmYear.map((month, index) => (
                                            <th className="Calendar-month" key={index}>
                                                {month.substring(0, 3)}
                                            </th>
                                        ))}
                                        <th colSpan={1}></th>
                                    </tr>
                                </thead>
                            )}
                            {otherApplication.applications.map((application, appIndex) => {
                                const monthGroupVal = validation[fu.monthGroupId(application.id)];
                                const amountVal = validation[fu.amountId(application.id)];
                                const rowErrors = monthGroupVal || amountVal;
                                var amount = application.amount;
                                var units = fertiliser.dairyFactoryEffluent && fertiliser.dairyFactoryEffluent === "Userdefined" ? "lt/ha" : utils.valueToText(fertiliserUnits, application.unit);
                                if (nutrientsOnApplication && application.nutrients) {
                                    amount = Object.keys(application.nutrients)
                                        .filter((n) => application.nutrients[n])
                                        .map((n) => n + ":" + application.nutrients[n])
                                        .join(", ");
                                }
                                return (
                                    <tbody key={appIndex}>
                                        {!fertiliser.isLastPreviousLime && (
                                            <tr name={`row_other_${rowIndex++}`} id={application.id} className={`${rowErrors ? "In-error" : ""}`}>
                                                <td colSpan="3">
                                                    <ActionLink className="FarmTable-value-link" onClick={() => editApplication(application.id)} id={`${application.id}_application_edit`} title="Edit">
                                                        <span>
                                                            Amount: {amount} <small>{units + "/month"}</small>
                                                        </span>
                                                        <span className="icon icon-edit"></span>
                                                    </ActionLink>
                                                </td>
                                                {farmYear.map((month, rIndx) => {
                                                    const checked = application.months.some((appMonth) => appMonth.month === month && appMonth.reportingYear === true);
                                                    return (
                                                        <td key={`${month}-${rIndx}`} style={{ textAlign: "center" }}>
                                                            <ApplicationMonth month={month} application={application} onChange={(e, t) => onChange(e, t)} key={rIndx} checked={checked} reportingYear={true} />
                                                        </td>
                                                    );
                                                })}
                                                <td>
                                                    <ActionLink className="IconLink--cross-circle" style={{ width: "16px" }} onClick={() => deleteApplication(application.id)} id={`${application.id}_application_remove`} title="Delete"></ActionLink>
                                                </td>
                                            </tr>
                                        )}
                                        {rowErrors && (
                                            <tr>
                                                <td colSpan={16}>
                                                    <div>
                                                        {monthGroupVal && (
                                                            <div className="u-textError u-textCenter" id="activity_other_month_error">
                                                                {monthGroupVal}
                                                            </div>
                                                        )}
                                                        {amountVal && (
                                                            <div className="u-textError u-textCenter" id="activity_other_amount_error-error">
                                                                Amount needs to be entered for this application
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                );
                            })}
                        </table>
                    </div>
                </div>
                {fertiliser.isLastPreviousLime && (
                    <div className="ActionsBar">
                        <div className="ActionsBar-right">
                            <ul className="ActionsBar-links">
                                <li>
                                    <div className="u-flex">
                                        <ActionLink className="IconLink--cross-circle" onClick={() => deleteApplication(otherApplication.applications[0].id)} id={`${otherApplication.applications[0].id}_application_remove`} title="Delete">
                                            <span>Delete</span>
                                        </ActionLink>
                                        <ActionLink className="IconLink--edit u-ml-sm" onClick={() => editApplication(otherApplication.applications[0].id)} id={`${otherApplication.applications[0].id}_application_edit`} title="Edit">
                                            <span>Edit</span>
                                        </ActionLink>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                )}
            </div>
        );
    });
};

export default ActivitySummary;
